import React from "react";
import { FormattedMessage } from "react-intl";

const PageNotAccessible = () => (
  <div className="m-4">
    <h1><FormattedMessage id="page_no_access" /></h1>
  </div>
);
export default PageNotAccessible;
